import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { gallaryEndpoints } from '../../../services/apis';
import { apiConnector } from '../../../services/apiConnector';

const GalleryForm = () => {
    const [title, setTitle] = useState('');
    const [images, setImages] = useState([]);

    const handleFileChange = (e) => {
        setImages([...e.target.files]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('title', title);
        images.forEach((image) => {
            formData.append('images', image);
        });

        try {
            const response = await apiConnector('POST', gallaryEndpoints.CREATE_GALLERY_API, formData);
            
            if (response.data.success) {
                toast.success('Gallery created successfully!');
                setTitle('');
                setImages([]);
            } else {
                throw new Error(response.data.message);
            }
        } catch (error) {
            console.error('CREATE GALLERY API ERROR....', error);
            toast.error('Failed to create gallery: ' + error.message);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#d1a319] to-[#47910a]">
            <form onSubmit={handleSubmit} className="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-2xl font-bold mb-6 text-[#CEA219] text-center">Create a New Gallery</h2>

                <div className="mb-4">
                    <label htmlFor="title" className="block text-sm font-medium text-richblack-700">
                        Title
                    </label>
                    <input
                        type="text"
                        id="title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="mt-1 block w-full px-4 py-2 border border-richblack-300 rounded-md shadow-sm focus:ring-blue-100 focus:border-blue-100"
                        placeholder="Enter gallery title"
                        required
                    />
                </div>

                <div className="mb-4">
                    <label htmlFor="images" className="block text-sm font-medium text-richblack-700">
                        Upload Images
                    </label>
                    <input
                        type="file"
                        id="images"
                        onChange={handleFileChange}
                        className="mt-1 block w-full px-4 py-2 border border-richblack-300 rounded-md shadow-sm focus:ring-richblack-500 focus:border-blue-100"
                        multiple
                        required
                    />
                    <p className="mt-2 text-sm text-richblack-500">You can upload multiple images.</p>
                </div>

                <button
                    type="submit"
                    className="w-full bg-richblack-600 text-white py-2 px-4 rounded-md shadow hover:bg-richblack-700 transition duration-200"
                >
                    Create Gallery
                </button>
            </form>
        </div>
    );
};

export default GalleryForm;
